import { ModalSheet, type SheetProps } from "./ModalSheet";
import "./drawer.css";

type Props = SheetProps & { open: boolean };

// Come Dialog, ma pannello ancorato a destra a tutta altezza; sotto i 720 px copre tutta la larghezza.
export function Drawer({ open, ...sheet }: Props) {
  return open ? <ModalSheet kind="drawer" {...sheet} /> : null;
}
